var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-0"},[_c('div',{staticClass:"text-center py-4 px-10 headline-4"},[_vm._v(" "+_vm._s(_vm.$t("x_id.x_id_text"))+" ")]),_c('e-button',{staticClass:"mt-4",attrs:{"block":true,"href":_vm.link,"variant":"primary","size":"large","large":""}},[_vm._v(" "+_vm._s(_vm.$t('password_login.login'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }